import React from 'react';

// INTERFACES
import { IContent } from '../../interfaces/Content.interface';

// STYLES
import { ContentStyled } from './styles';

const Content: React.FC<IContent> = ({
  children, 
  ...restProps
}: IContent) => {
  return (
    <ContentStyled {...restProps}>
      {children}
    </ContentStyled>
  );
};

export default Content;
